import type { FC } from "react";
import type { Theme } from "@mui/material/styles";
import type { DpiaStatus } from "../../api/dpia.types";
import { statusColors as registrationStatusColors } from "../../shared/RegistrationStatus";
import { StatusChip, type Colors } from "../../shared/StatusChip";

type VisibleDpiaStatuses = Exclude<DpiaStatus, "preAssessment">;

export const statusColors: Record<VisibleDpiaStatuses, Colors & { dot: (theme: Theme) => string }> = {
  draft: registrationStatusColors.draft,
  approved: registrationStatusColors.done,
  waitingForDecision: registrationStatusColors.review,
  rejected: {
    border: theme => theme.palette.brandRed["400"],
    background: theme => theme.palette.brandRed["100"],
    text: theme => theme.palette.brandRed["800"],
    dot: theme => theme.palette.brandRed["500"],
  },
};

export const DpiaStatusChip: FC<{ status: VisibleDpiaStatuses }> = ({ status }) => (
  <StatusChip colors={statusColors[status]} labelKey={`DpiaStatus.${status}`} />
);
